import type { CurrentUser, Membership } from './auth-store';

export function getActiveMembership(user: CurrentUser | null, activeTenantId: string | null): Membership | null {
  if (!user) {
    return null;
  }

  if (activeTenantId) {
    const membership = user.memberships.find((item) => item.tenantId === activeTenantId);
    if (membership) {
      return membership;
    }
  }

  return user.memberships[0] || null;
}

export function isSuperAdminGlobal(user: CurrentUser | null): boolean {
  return user?.globalRole === 'SUPER_ADMIN';
}

export function canAccessPath(input: {
  pathname: string;
  globalRole: CurrentUser['globalRole'] | null;
  tenantRole: Membership['role'] | null;
}): boolean {
  if (input.globalRole === 'SUPER_ADMIN') {
    return true;
  }

  const path = input.pathname;
  const role = input.tenantRole;

  if (!role) {
    return path.startsWith('/login');
  }

  if (role === 'LOCATION_USER') {
    return (
      path.startsWith('/dashboard') ||
      path.startsWith('/locations') ||
      path.startsWith('/reset-password') ||
      path === '/'
    );
  }

  if (role === 'AGENCY' || role === 'AGENCY_DEMO' || role === 'ADMIN') {
    if (path.startsWith('/admin')) {
      return false;
    }

    return true;
  }

  return true;
}

export function canSeeTokenEconomics(input: {
  globalRole: CurrentUser['globalRole'] | null;
}): boolean {
  return input.globalRole === 'SUPER_ADMIN';
}

export function isAgencyScopeRole(role: Membership['role'] | null): boolean {
  return role === 'AGENCY' || role === 'AGENCY_DEMO';
}
